import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { UiBlockerOverlayComponent } from '@ui-blocker';
import { navigationMenu } from './navigation-menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListItem, MatListItemIcon, MatListItemTitle, MatNavList } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    UiBlockerOverlayComponent,
    MatSidenavModule,
    MatNavList,
    MatIcon,
    MatButton,
    MatListItem,
    MatListItemIcon,
    MatListItemTitle,
  ],
})
export class ShellComponent {
  private readonly authService = inject(MsalService);
  readonly links = navigationMenu;

  onLogout(): void {
    this.authService.logout();
  }
}
